import _toConsumableArray from "/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import queryString from 'query-string';
import { compact, concat, map, mergeAll, pipe, replace, split, startsWith } from 'lodash/fp';
import buildLink from './buildLink';
/**
 * Uel building utility designed to make constructing urls painless. Loosely
 * based on: https://www.npmjs.com/package/url-assembler
 *
 * @param {string} [initialUrl] - initial part of the url, to which
 * other
 * parts will be appended
 *
 * @returns {UrlBuilder} - reference to newly created builder object
 *
 * @example
 * return UrlBuilder('https//base')
 *   .template('/page/:id')
 *   .addParam({ id: 3 })
 *   .addQuery({ filter: true })
 *   .joinHash('some-hash)
 *   .toString()
 */

export default function UrlBuilder(initialUrl) {
  function newState(oldState) {
    var changes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return mergeAll([{}, oldState, changes]);
  }

  function newBuilder(state) {
    return {
      template: function template(_template) {
        return newBuilder(newState(state, {
          template: _template
        }));
      },
      addParam: function addParam(param) {
        return newBuilder(newState(state, {
          param: param
        }));
      },
      addQuery: function addQuery(query, options) {
        return newBuilder(newState(state, {
          query: query,
          options: options
        }));
      },
      joinHash: function joinHash(hash) {
        return newBuilder(newState(state, {
          hash: hash
        }));
      },
      toString: function toString() {
        var _state$template = state.template,
            template = _state$template === void 0 ? '/' : _state$template,
            url = state.url,
            param = state.param,
            query = state.query,
            hash = state.hash,
            options = state.options;
        var pathname = pipe(split('/'), map(function (part) {
          if (startsWith(':', part)) {
            if (param[part.substring(1)]) {
              return param[part.substring(1)];
            }

            return null;
          }

          return part;
        }), concat(['/', url]), compact, function (parts) {
          return buildLink.apply(void 0, _toConsumableArray(parts));
        }, replace(/(\/)\1+/g, '/'), function (result) {
          return result.length > 1 ? replace(/\/$/, '', result) : result;
        })(template);
        var search = queryString.stringify(query, options);
        return "".concat(pathname).concat(search ? "?".concat(search) : '').concat(hash ? "#".concat(hash) : '');
      }
    };
  }

  return newBuilder({
    hash: '',
    options: {},
    param: {},
    query: {},
    template: '',
    url: initialUrl
  });
}